export const ProductStatusCssClasses = [
  'danger',
  'primary',
  'warning',
  'success',
  '',
];
export const ProductStatusTitles = ['Yard', 'Sea', 'Custom', 'Delivered'];
export const ProductConditionCssClasses = ['success', 'danger', ''];
export const ProductConditionTitles = ['New', 'Used'];
export const defaultSorted = [{ dataField: 'id', order: 'asc' }];
export const sizePerPageList = [
  { text: '10', value: 10 },
  { text: '20', value: 20 },
  { text: '30', value: 30 },
];
export const initialFilter = {
  filter: {
    model: '',
    brand: '',
    name: '',
    status: '',
  },
  sortOrder: 'asc', // asc||desc
  sortField: 'id',
  pageNumber: 1,
  pageSize: 10,
};
export const AVAILABLE_COLORS = [
  'Red',
  'CadetBlue',
  'Eagle',
  'Gold',
  'LightSlateGrey',
  'RoyalBlue',
  'Crimson',
  'Blue',
  'Sienna',
  'Indigo',
  'Green',
  'Violet',
  'GoldenRod',
  'OrangeRed',
  'Khaki',
  'Teal',
  'Purple',
  'Orange',
  'Pink',
  'Black',
  'DarkTurquoise',
];

export const AVAILABLE_MANUFACTURES = [
  'Pontiac',
  'Kia',
  'Lotus',
  'Subaru',
  'Jeep',
  'Isuzu',
  'Mitsubishi',
  'Oldsmobile',
  'Chevrolet',
  'Chrysler',
  'Audi',
  'Suzuki',
  'GMC',
  'Cadillac',
  'Infinity',
  'Mercury',
  'Dodge',
  'Ram',
  'Lexus',
  'Lamborghini',
  'Honda',
  'Nissan',
  'Ford',
  'Hyundai',
  'Saab',
  'Toyota',
];
